import gql from 'graphql-tag';
export const MOTIVES = gql`
query{
	motivos {
	  MtId
	  MtNombre
	}
}
`;